import React from 'react'
import { Div, Flex, Text } from '@sendoutcards/quantum-design-ui'
import styles from './expenseInfo.module.scss'

const ExpenseInfo: React.FC = () => {
  return (
    <Div className={styles.main}>
      <Flex alignItems="center" columnGap="x1_5">
        <img
          src="https://www.sendoutcards.com/static/images/stamps/heart_stamp.png"
          alt="US Stamp"
        />
        <Text type="caption">
          If sending a single card within the US, add at least $1.00 of expense
          to cover the $0.55 postage.
        </Text>
      </Flex>
      <Flex alignItems="center" columnGap="x1_5">
        <img
          src="https://www.sendoutcards.com/static/images/stamps/circus_stamp.png"
          alt="Global Stamp"
        />
        <Text type="caption">
          If sending a single card internationally, add at least $2.00 of
          expense to cover the $1.20 postage.
        </Text>
      </Flex>
    </Div>
  )
}

export default ExpenseInfo
